<template>
  <div class="login">
    <div class="form" v-if="!email">
      <div class="form__group">
        <p>Log in or Sign up</p>
        <text-input id="email" placeholder="email@address.com" v-model="localEmail" />
      </div>
      <div class="form__group">
        <button @click="login()" :disabled="!localEmail">Send login link</button>
      </div>
    </div>
    <div class="success" v-else>
      <div class="success__image" v-if="justPaid">
        <img
        src="/images/ify_thanks.jpg"
        alt="Ify says 'Thanks for paying for JAND.
         I hope you'll enjoy reading'"
        />
      </div>
      <h3 v-else>Please check your email</h3>
      <p>We sent your login link to <br> {{email}}</p>
      <div class="buttons">
        <button class="is-light" @click="resend()" :disabled="resending">
          <span v-if="resending">Sending</span>
          <span v-else>Resend link</span>
        </button>
        <router-link :to="{name: 'Login'}" class="g-button is-light">
          <span>Change email</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import TextInput from '@/components/TextInput.vue';

export default {
  name: 'Login',
  components: {
    TextInput,
  },
  data() {
    const { email, stripNumber, justPaid } = this.$route.query;
    return {
      email,
      localEmail: email,
      stripNumber,
      justPaid,
      error: null,
      resending: false,
    };
  },
  watch: {
    $route(to) {
      this.email = to.query.email;
      this.stripNumber = to.query.stripNumber;
    },
  },
  methods: {
    ...mapActions([
      'set',
      'sendLoginLink',
    ]),
    login() {
      this.email = this.localEmail;
      const query = { email: this.localEmail };
      this.$router.replace({ query });
      this.sendLoginLink(this.email);
    },
    resend() {
      this.resending = true;
      this.sendLoginLink(this.email).finally(() => {
        this.resending = false;
      });
    },
  },
  mounted() {
    if (this.email) {
      this.sendLoginLink(this.email);
    }
  },
};
</script>

<style lang="scss" scoped>
.login {
  margin: 0 auto;
  padding: 0 20px;
  max-width: 500px;
  text-align: center;
  &__error {
    margin: 0 auto;
    text-align: center;
  }
  &__actions {
    div {
      margin: 20px;
    }
  }
  .buttons {
    > * {
      margin: 5px;
    }
  }
  .form {
    margin: 30px auto;
    max-width: 300px;
    &__group {
      margin-top: 15px;
      position: relative;
    }
    button {
      width: 100%;
    }
  }
}
</style>
